const assignedContractExt=async(data)=>{
    // const host =`https://api-intranet-credicor.herokuapp.com/`
    // const host = `http://localhost:3400/`
    const host = process.env.REACT_APP_URL_API_INTRANET;
    const url=`${host}api/comisiones/asignarcontratoext`;
    const token=localStorage.getItem('token')
    const resp = await fetch(url, {
        method: "POST", // or 'PUT'
        headers: {
            "Content-Type": "application/json",
            "Authorization": token
        },
        body: JSON.stringify(data)
    });
        const { Success, Message, Error } = await resp.json();
        let idx = 0;
        let assignedContExt
        if ( Success ) {
            assignedContExt = { Success, Message }
        } else {
            assignedContExt = { idx:idx+=1, Success, Message: Message, Error };
        }
        return assignedContExt;
}

export default assignedContractExt;
